import axios from "axios";

const api = axios.create({
    baseURL: "https://uaedubaihotels.com/api",
});

export default api;